<template>
  <div class="sign-up">
    <v-dialog
      v-model="showSignUpDialog"
      max-width="400px"
      persistent
      :fullscreen="breakpoint.xsOnly"
      :hide-overlay="breakpoint.xsOnly"
    >
      <v-card rounded center>
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-toolbar-title>Sign up</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showSignUpDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-show="showSignupForm">
          <v-form ref="form" teal>
            <v-text-field
              v-model="userDisplayName"
              label="Your name"
              color="teal"
              class="mt-2"
              autofocus
              :rules="userDisplayNameRules"
              @keyup.enter="signUpWithMail"
            ></v-text-field>

            <v-text-field
              v-model="signUpEmail"
              label="E-mail"
              color="teal"
              class="mt-2"
              :rules="signUpEmailRules"
              @keyup.enter="signUpWithMail"
            ></v-text-field>

            <v-text-field
              v-model="signUpPassword"
              label="Password"
              type="password"
              color="teal"
              class="mt-2"
              :rules="signUpPasswordRules"
              @keyup.enter="signUpWithMail"
            ></v-text-field>
            <div class="red--text text-xs-center mt-2 mb-4" v-show="feedback">
              {{ feedback }}
            </div>
            <v-btn
              class="mt-2 mb-4"
              block
              color="teal"
              dark
              large
              @click="signUpWithMail"
              >
              <span v-show="!showSignUpWithEmailSpinner">Sign Up</span>
              <v-progress-circular
                v-show="showSignUpWithEmailSpinner"
                size="28"
                width="3"
                indeterminate
                color="teal lighten-3"> 
              </v-progress-circular>
              </v-btn
            >

            <!-- Social sign in -->

            <p class="continue-with mt-4">
              <span>Or continue with</span>
            </p>
            <v-btn
              class="mt-8"
              color="blue darken-2"
              dark
              block
              large
              @click="logInWithProvider('facebook', 'signup')"
            >
              <span v-show="!showFacebookLoginSpinner">Facebook</span>
              <v-progress-circular
                v-show="showFacebookLoginSpinner"
                size="28"
                width="3"
                indeterminate
                color="blue lighten-3"
              >
              </v-progress-circular>
            </v-btn>

            <v-btn
              class="mt-4"
              color="red darken-1"
              dark
              block
              large
              @click="logInWithProvider('google', 'signup')"
            >
              <span v-show="!showGoogleLoginSpinner">Google</span>
              <v-progress-circular
                size="28"
                width="3"
                v-show="showGoogleLoginSpinner"
                indeterminate
                color="red lighten-3"
              >
              </v-progress-circular>
            </v-btn>
          </v-form>
        </v-card-text>

        <v-card-text v-show="emailVerificationSent" class="text-xs-center">
          <p>An email has been sent to {{ signUpEmail }}</p>

          <p>
            Please click the link in the email to verify your email address.
          </p>
          <p>(Please allow up to 5 minutes for the email to arrive)</p>
          <p class="red--text">Important! After you have verified your email click OK and sign in again!</p>
          <p>
            Didn't get an email?
            <a @click.prevent="resendVerificationEmail"
              >Resend verification email.</a
            >
          </p>
          <p v-show="showResendErrorMessage" class="red--text">
            There has been an error, please try again later!
          </p>
          <v-btn @click="closeDialogAndSignOut" color="teal" dark large
            >OK</v-btn
          >
        </v-card-text>

        <v-card-text v-show="emailVerificationResent" class="text-xs-center">
          <p>We sent you another email.</p>
          <p class="red--text">Important! After you have verified your email click OK and sign in again!</p>
          <p>
            Still didn't receive it?
            <a href="https://www.earbeater.com/contact/" target="_blank"
              >Contact support.</a
            >
          </p>
          <v-btn @click="closeDialogAndSignOut" color="teal" dark large
            >OK</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase/app";
import setupNewUserInDatabase from "@/mixins/setupNewUserInDatabase";
import logInWithProvider from "@/mixins/logInWithProvider";
export default {
  name: "signUp",
  mixins: [setupNewUserInDatabase, logInWithProvider],
  data() {
    return {
      userDisplayName: "",
      signUpEmail: "",
      signUpPassword: "",
      feedback: null,
      showSignupForm: true,
      emailVerificationSent: false,
      emailVerificationResent: false,
      showResendErrorMessage: false,
      showSignUpWithEmailSpinner: false,
      showFacebookLoginSpinner: false,
      showGoogleLoginSpinner: false,
      userDisplayNameRules: [(v) => v.length > 0 || "You must enter your name"],
      signUpEmailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      signUpPasswordRules: [
        (v) => !!v || "You must enter a password",
        (v) => v.length > 6 || "Your password must be longer than 6 characters",
      ],
    };
  },
  methods: {
    signUpWithMail() {
      // Check fields are filled out // ADD display name to check
      if (
        this.signUpEmail.length === 0 ||
        this.signUpPassword.length === 0 ||
        this.userDisplayName.length === 0
      ) {
        this.feedback = "Please fill out all the form fields";
        return;
      }
      // show spinner 
      this.showSignUpWithEmailSpinner = true;
      // Create user
      return firebase
        .auth()
        .createUserWithEmailAndPassword(this.signUpEmail, this.signUpPassword)
        .then((cred) => {
          // Set Displayname here
          cred.user
            .updateProfile({
              displayName: this.userDisplayName,
            })
            .then(() => {
              // Send verification email
              let user = cred.user;
              user.sendEmailVerification().then(() => {
                // Show that user needs to confirm email and send verification email
                this.emailVerificationSent = true;
                this.showSignupForm = false;

                // Maybe not necessary to sign out.. Just check if provider is email and it is authorised
                // firebase.auth().signOut().then(() => {
                //     console.log("User signed out");
                //   });
              });
            })
            .catch((err) => {
              this.showSignUpWithEmailSpinner = false;
              this.feedback = `Could not set user display name: ${err.message}`;
            });
        })
        .catch((err) => {
          this.showSignUpWithEmailSpinner = false;
          this.feedback = err.message;
        });
    },
    resendVerificationEmail() {
      let user = firebase.auth().currentUser;
      user.reload().then(() => {
        user
          .sendEmailVerification()
          .then(() => {
            // Email sent.
            this.emailVerificationResent = true;
            this.emailVerificationSent = false;
            this.showSignupForm = false;
          })
          .catch((error) => {
            // An error happened.
            console.log(error.message);
            this.showResendErrorMessage = true;
          });
      });
    },
    closeDialogAndSignOut() {
      this.showSignUpWithEmailSpinner = false;
      firebase.auth().signOut().then(() => {
        this.showSignUpDialog = false;
        // Show snackbar
        this.$store.dispatch('setSnackbar', {
            timeout: 5000,
            text: 'You have been signed out. Verify your email and sign in again'
          });
      });
    }
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showSignUpDialog: {
      get() {
        return this.$store.getters.getShowSignUpDialog;
      },
      set(value) {
        this.$store.dispatch("setShowSignUpDialog", value);
      },
    },
  },
  watch: {
    showSignUpDialog() {
      this.$refs.form.resetValidation();
      this.userDisplayName = "";
      this.signUpEmail = "";
      this.signUpPassword = "";
      this.feedback = "";

      // Reset
      this.showSignupForm = true;
      this.emailVerificationSent = false;
      this.emailVerificationResent = false;
      this.showResendErrorMessage = false;
    },
  },
};
</script>

<style>
.continue-with {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #ddd;
  line-height: 0.1em;
  margin: 10px 0 20px;
}
.continue-with span {
  background-color: #fff;
  padding: 0 10px;
}
</style>